import { useRouter } from 'next/router';
import React from 'react';

import { Button } from '../Button/Button';
import { Card } from '../Card/Card';

import styles from './NotFound.module.scss';

interface NotFoundProps {
  entity: string;
  listRoute: string;
  listLabel: string;
  message?: React.ReactNode;
}

export const NotFound: React.FC<NotFoundProps> = ({ entity, listRoute, listLabel, message }) => {
  const { push } = useRouter();

  return (
    <div className={styles.wrapper}>
      <Card className={styles.card}>
        <h2 className={styles.title}>{entity} not found</h2>
        <p className={styles.subtitle}>{message ?? 'It may have been deleted, or the link may be wrong.'}</p>
        <Button
          view="primary"
          onClick={() => push(listRoute)}
        >
          ← {listLabel}
        </Button>
      </Card>
    </div>
  );
};
